import { createTheme } from '@mui/material/styles';

/**
 * Identité visuelle du parcours assuré, distincte du front expert.
 *
 * L'assuré qui arrive ici vient de subir un sinistre : l'interface doit être
 * calme et lisible, pas dense comme un outil de professionnel. D'où de grandes
 * respirations, une typographie lisible et une palette sobre.
 */
export const themeAssure = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1f4e5f', light: '#33707f', dark: '#143641' },
    secondary: { main: '#c2703d' },
    success: { main: '#2e7d5b' },
    warning: { main: '#b9741f' },
    error: { main: '#9d3b32' },
    background: { default: '#f6f4f1', paper: '#ffffff' },
    text: { primary: '#22262a', secondary: '#5b636b' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
    h1: { fontSize: '1.9rem', fontWeight: 600, letterSpacing: '-0.01em' },
    h2: { fontSize: '1.45rem', fontWeight: 600 },
    h3: { fontSize: '1.15rem', fontWeight: 600 },
    body1: { fontSize: '1rem', lineHeight: 1.65 },
    body2: { fontSize: '0.9rem', lineHeight: 1.6 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { paddingInline: 20, paddingBlock: 9 } },
    },
    MuiTextField: { defaultProps: { fullWidth: true } },
    MuiPaper: {
      styleOverrides: {
        outlined: { borderColor: '#e2ddd6' },
      },
    },
  },
});

export default themeAssure;
